import React from 'react';

export default function QtyStepper({
  value,
  onChange,
  min = 1,
  max = 99,
  disabled = false,
  label = 'Quantity',
  size = 'md', // xs | card | sm | md
}) {
  const n = Math.max(min, Math.min(max, Number(value) || min));

  const bump = (delta) => {
    const next = n + delta;
    if (next < min) onChange(0);
    else onChange(Math.min(max, next));
  };

  return (
    <div className={`qty-stepper qty-stepper--${size}`} role="group" aria-label={label}>
      <button
        type="button"
        className="qty-stepper__btn"
        onClick={() => bump(-1)}
        disabled={disabled || n <= min}
        aria-label="Decrease quantity"
      >
        −
      </button>
      <span className="qty-stepper__value" aria-live="polite">
        {n}
      </span>
      <button
        type="button"
        className="qty-stepper__btn"
        onClick={() => bump(1)}
        disabled={disabled || n >= max}
        aria-label="Increase quantity"
      >
        +
      </button>
    </div>
  );
}
